<div
  class="bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 p-5 shadow-xs flex items-start gap-4"
>
  <div class="p-3 rounded-xl bg-primary-2 text-primary-11 shrink-0">
    <mat-icon class="size-6">badge</mat-icon>
  </div>
  <div class="flex-1 min-w-0 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    <div class="flex flex-col">
      <span class="text-xs text-neutral-10 font-medium uppercase tracking-wider"
        >Type d'exercice & Réseau</span
      >
      <div class="flex items-center gap-3 mt-1 flex-wrap">
        <span class="text-lg font-bold text-neutral-12">
          @if (resolvedType() === 'titulaire') {
            Titulaire carte T
          } @else {
            Mandataire immobilier
          }
        </span>
        @if (resolvedNetwork()) {
          <span
            class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-bold bg-primary-2 text-primary-11 border border-primary-4"
          >
            {{ resolvedNetwork() }}
          </span>
        }
      </div>
      <span class="text-xs text-neutral-10 mt-1">
        @if (resolvedType() === 'titulaire') {
          Détenteur légal de la carte professionnelle d'agent immobilier.
        } @else {
          Agent commercial ou mandataire rattaché à une agence ou réseau titulaire.
        }
      </span>
    </div>

    @if (showLinkToAgentPage() && profile()?._id) {
      <div class="shrink-0">
        <a
          [routerLink]="['/agents', profile()!._id]"
          class="inline-flex items-center gap-2 px-3.5 py-1.5 text-xs font-semibold text-primary-11 bg-primary-2 hover:bg-primary-3 border border-primary-4 rounded-lg transition-all cursor-pointer font-sans"
        >
          <mat-icon class="size-4 !text-sm">badge</mat-icon>
          <span>Fiche agent détaillée</span>
        </a>
      </div>
    }
  </div>
</div>
